/**
 * The daily board. One world for everyone, reset at 00:00 UTC. The core never reads the clock:
 * the app passes a timestamp or a day number in. See spec/core-spec.md, section "Daily seed".
 */
import { mix32 } from "./hash.ts";

export const MS_PER_DAY = 86_400_000;

export const DAILY_SALT = 0x4441494c; // "DAIL"

/** Day number of expedition #1: 2026-11-04 UTC, counted on from there (decision 0016). Changing it only renumbers. */
export const LAUNCH_DAY = 20761;

/** Days since 1970-01-01 UTC. */
export function dayNumber(unixMs: number): number {
  return Math.floor(unixMs / MS_PER_DAY);
}

/** The world seed for a day number, as an unsigned 32-bit integer. */
export function dailySeed(day: number): number {
  return mix32(day, 0, DAILY_SALT);
}

/** The number shown to players: expedition #1 is LAUNCH_DAY. */
export function expeditionNumber(day: number): number {
  return day - LAUNCH_DAY + 1;
}

/** Milliseconds until the next reset. */
export function msUntilNextDay(unixMs: number): number {
  return (dayNumber(unixMs) + 1) * MS_PER_DAY - unixMs;
}
